<template>
    <b-container>
        <h1 style="margin-top: 150px;">{{ErrorHeader || "Title"}}</h1>
        <h4 style="">{{ ErrorSubHeader || "Subtitle"}}</h4>
    </b-container>
</template>


<script>

import '../assets/demo.css'
import '../assets/light-bootstrap-dashboard.css'


export default {
  name: "ErrorView",
  props:
  {
      ErrorHeader:
      {
          type: String,
          default: "Header"
      },
      ErrorSubHeader:
      {
          type: String,
          default: "Subheader"
      }
  },
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    onLoad: function() {
        console.log(this.ErrorHeader);
    }
  },
  beforeMount() {
    this.onLoad();
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #929292;
}

#LandingText
{
  text-align: left;
  margin-left: 15px;
}

#LandingMessage
{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorView.vue